module.exports = __webpack_public_path__ + "static/img/case_12.22f4ac0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_12.jpg
// module id = 6Snn
// module chunks = 0